import { FC } from 'react';
import { Button, Input } from 'antd';

import Modal from '../../../components/Modal/Modal';
import { ListenerFullRow } from '../CourseEnrollment.const';
import { FormUpdater } from '../CourseEnrollment.types';
import css from '../CourseEnrollment.module.css';

interface Props {
  open: boolean;
  isEditMode: boolean;
  listener: ListenerFullRow | null;
  onChange: FormUpdater<ListenerFullRow>;
  onClose: () => void;
  onSave: () => void;
}

const formatPassportDate = (raw: string): string => {
  const digits = raw.replace(/\D/g, '').slice(0, 8);
  if (digits.length > 4) {
    return `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
  }
  if (digits.length > 2) {
    return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  }
  return digits;
};

const isValidPassportDate = (val: string): boolean => {
  if (!/^\d{2}\.\d{2}\.\d{4}$/.test(val)) return false;
  const [d, m, y] = val.split('.').map(Number);
  const dt = new Date(y, m - 1, d);
  return dt.getFullYear() === y && dt.getMonth() === m - 1 && dt.getDate() === d;
};

const ListenerModal: FC<Props> = ({
  open,
  isEditMode,
  listener,
  onChange,
  onClose,
  onSave,
}) => (
  <Modal
    display={open}
    onClose={onClose}
    title={isEditMode ? 'Редактирование слушателя' : 'Новый слушатель'}
  >
    {listener && (
      <div className={css.ListenerModal}>
        <div className={css.FormGrid}>
          <div className={`${css.Field} ${css.FieldFull}`}>
            <span className={css.FieldLabel}>ФИО на русском *</span>
            <Input
              placeholder='Иванов Иван Иванович'
              value={listener.fullNameRu}
              onChange={(e) => onChange('fullNameRu', e.target.value)}
            />
          </div>
          <div className={`${css.Field} ${css.FieldFull}`}>
            <span className={css.FieldLabel}>ФИО на белорусском *</span>
            <Input
              placeholder='Іванаў Іван Іванавіч'
              value={listener.fullNameBy}
              onChange={(e) => onChange('fullNameBy', e.target.value)}
            />
          </div>
          <div className={`${css.Field} ${css.FieldFull}`}>
            <span className={css.FieldLabel}>Адрес *</span>
            <Input
              placeholder='г. Минск, ул. ..., д. ..., кв. ...'
              value={listener.address}
              onChange={(e) => onChange('address', e.target.value)}
            />
          </div>
          <div className={css.Field}>
            <span className={css.FieldLabel}>Серия и номер паспорта *</span>
            <Input
              placeholder='MP1234567'
              value={listener.passport}
              onChange={(e) => onChange('passport', e.target.value)}
            />
          </div>
          <div className={css.Field}>
            <span className={css.FieldLabel}>Дата выдачи *</span>
            <Input
              placeholder='ДД.ММ.ГГГГ'
              value={listener.passportIssueDate}
              maxLength={10}
              status={
                listener.passportIssueDate.length === 10 && !isValidPassportDate(listener.passportIssueDate)
                  ? 'error'
                  : undefined
              }
              onChange={(e) => onChange('passportIssueDate', formatPassportDate(e.target.value))}
            />
          </div>
          <div className={`${css.Field} ${css.FieldFull}`}>
            <span className={css.FieldLabel}>Кем выдан *</span>
            <Input
              placeholder='УВД г. Минска'
              value={listener.passportIssuer}
              onChange={(e) => onChange('passportIssuer', e.target.value)}
            />
          </div>
          <div className={`${css.Field} ${css.FieldFull}`}>
            <span className={css.FieldLabel}>E-mail для доступа *</span>
            <Input
              placeholder='example@mail.com'
              value={listener.externalEmail}
              onChange={(e) => onChange('externalEmail', e.target.value)}
            />
          </div>
        </div>

        <div className={css.ModalFooter}>
          <Button className={css.BackBtn} onClick={onClose}>
            Отмена
          </Button>
          <Button type='primary' className={css.NextBtn} onClick={onSave}>
            {isEditMode ? 'Сохранить' : 'Добавить'}
          </Button>
        </div>
      </div>
    )}
  </Modal>
);

export default ListenerModal;
